/**
 * A/B Test: Summer Sale free gifts (SVG/PNG cards)
 *
 * body attribute (IntelliGems / AB tool):
 *   data-elios-free-gifts-test="false" → Control — keep existing gift cards
 *   data-elios-free-gifts-test="true"  → Variant — gifts block above ATC
 *
 * Dev preview: ?elios_free_gifts_test=b  (or true / 1)
 */
(function () {
  'use strict';

  if (window.__eliosFreeGiftsABTestInit) return;
  window.__eliosFreeGiftsABTestInit = true;

  var BODY_ATTR = 'data-elios-free-gifts-test';
  var VARIANT_ATTR = 'data-elios-fg-variant';
  var SOURCE_ATTR = 'data-elios-fg-source';
  var ACTIVE_CLASS = 'elios-free-gifts-ab--active';
  var MARK = 'data-elios-fg-self';
  var VERSION = '11';

  var GIFTS = [
    {
      key: 'shipping',
      label: 'Livraison gratuite',
      match: /livraison\s+gratuite|free\s+(?:shipping|delivery)|t[eê]te\s+de\s+rechange/i
    },
    {
      key: 'gant',
      label: 'Gant exfoliant ELIOS',
      match: /gant\s+exfoliant|exfoliat(?:ing)?\s+glove/i
    },
    {
      key: 'kit',
      label: 'Kit 5 têtes + 3 sabots ELIOS',
      match: /kit\s*5|t[eê]tes?\s*\+|sabots|5-head|3-comb/i
    },
    {
      key: 'bonus',
      label: 'Cadeau bonus',
      match: /cadeau\s+bonus|bonus\s+gift|free\s+gift/i
    }
  ];

  var applying = false;
  var lastEnabled = null;
  var settleTimers = [];
  var attrObserver = null;

  function cfg() {
    return window.__eliosFreeGiftsAB || {};
  }

  function isDevVariantB() {
    try {
      var v = new URLSearchParams(window.location.search).get('elios_free_gifts_test');
      return v === 'b' || v === 'true' || v === '1';
    } catch (e) {
      return false;
    }
  }

  function isTruthy(value) {
    var normalized = String(value || '')
      .trim()
      .toLowerCase();
    return normalized === 'true' || normalized === '1' || normalized === 'on' || normalized === 'yes';
  }

  function getBodyAttr() {
    if (document.body && document.body.hasAttribute(BODY_ATTR)) {
      return document.body.getAttribute(BODY_ATTR);
    }
    if (document.documentElement && document.documentElement.hasAttribute(BODY_ATTR)) {
      return document.documentElement.getAttribute(BODY_ATTR);
    }
    return null;
  }

  function isAbEnabled() {
    if (isDevVariantB()) return true;
    return isTruthy(getBodyAttr());
  }

  function isProductPage() {
    if (!document.body) return false;
    if (document.body.classList.contains('template-product')) return true;
    return /\/products\//.test(window.location.pathname || '');
  }

  function textOf(el) {
    return ((el && el.textContent) || '').replace(/\s+/g, ' ').trim();
  }

  /** Trust / features row — never treat as gift source */
  function isTrustBadgeNode(el) {
    if (!el || !el.closest) return false;
    if (
      el.closest(
        '.features-wrapper, .features-container, .feature-item, .feature-title, .feature-subtitle, .text-with-icons, .text-with-icons__text-wrapper, .icon-with-text'
      )
    ) {
      return true;
    }
    var t = textOf(el);
    if (
      /ready\s+to\s+ship|ships?\s+in\s+24|pr[eê]t\s+[àa]\s+[eê]tre\s+livr|exp[eé]di[eé]\s+en\s+24|satisfaction\s+guaranteed|satisfait\s+ou\s+rembours/i.test(
        t
      )
    ) {
      return true;
    }
    return false;
  }

  function isUnsafeToHide(el) {
    if (!el || !el.tagName) return true;
    var tag = el.tagName.toLowerCase();
    if (tag === 'body' || tag === 'html' || tag === 'main' || tag === 'header' || tag === 'footer') {
      return true;
    }
    if (el.id === 'main' || el.id === 'MainContent') return true;
    if (el.matches && el.matches('form, product-info, .product, .product-info, .shopify-section')) {
      return true;
    }
    if (el.querySelector && el.querySelector('buy-buttons, button[name="add"], .buy-buttons')) {
      return true;
    }
    if (isTrustBadgeNode(el)) return true;
    if (
      el.querySelector &&
      el.querySelector('.features-wrapper, .features-container, .feature-item, .feature-title, .text-with-icons')
    ) {
      return true;
    }
    if (textOf(el).length > 2500) return true;
    return false;
  }

  function findLabelNodes() {
    var found = [];
    var candidates = document.querySelectorAll('p, span, div, li, strong, label, figcaption, h4, h5');

    for (var i = 0; i < candidates.length; i += 1) {
      var el = candidates[i];
      if (el.closest && el.closest('[' + VARIANT_ATTR + '], [' + MARK + ']')) continue;
      if (isTrustBadgeNode(el)) continue;
      var text = textOf(el);
      if (!text || text.length > 80) continue;

      for (var g = 0; g < GIFTS.length; g += 1) {
        if (GIFTS[g].match.test(text)) {
          found.push({ gift: GIFTS[g], node: el });
          break;
        }
      }
    }

    return found;
  }

  function closestCard(node) {
    if (!node) return null;
    var el = node;
    for (var depth = 0; depth < 6 && el; depth += 1) {
      if (el.querySelector && el.querySelector('img')) return el;
      el = el.parentElement;
    }
    return node.parentElement || node;
  }

  function findSourceRoot(labelHits) {
    if (!labelHits || labelHits.length < 2) return null;

    var cards = [];
    for (var i = 0; i < labelHits.length; i += 1) {
      var card = closestCard(labelHits[i].node);
      if (card && cards.indexOf(card) === -1) cards.push(card);
    }
    if (cards.length < 2) return null;

    var root = cards[0];
    for (var j = 1; j < cards.length; j += 1) {
      while (root && !root.contains(cards[j])) root = root.parentElement;
    }

    if (!root || isUnsafeToHide(root)) return null;

    if (root.children && root.children.length >= 4 && root.children.length <= 8 && !isUnsafeToHide(root)) {
      return root;
    }

    if (root.children) {
      for (var c = 0; c < root.children.length; c += 1) {
        var child = root.children[c];
        var hit = 0;
        for (var k = 0; k < cards.length; k += 1) {
          if (child.contains(cards[k])) hit += 1;
        }
        if (hit >= 2 && !isUnsafeToHide(child)) return child;
      }
    }

    return isUnsafeToHide(root) ? null : root;
  }

  function findSourceCards(labelHits) {
    var cards = [];
    if (!labelHits) return cards;
    for (var i = 0; i < labelHits.length; i += 1) {
      var card = closestCard(labelHits[i].node);
      if (card && !isUnsafeToHide(card) && cards.indexOf(card) === -1) {
        cards.push(card);
      }
    }
    return cards;
  }

  function isVisible(el) {
    if (!el || !el.getBoundingClientRect) return false;
    var rect = el.getBoundingClientRect();
    return rect.width > 0 && rect.height > 0;
  }

  function looksLikeAtc(el) {
    if (!el) return false;
    var t = textOf(el).toLowerCase();
    if (
      t.indexOf('add to cart') > -1 ||
      t.indexOf('ajouter au panier') > -1 ||
      t.indexOf('add to bag') > -1 ||
      t.indexOf('buy it now') > -1 ||
      t === 'ajouter' ||
      t === 'acheter'
    ) {
      return true;
    }
    if (el.getAttribute && el.getAttribute('name') === 'add') return true;
    return false;
  }

  function getAtcButton() {
    var selectors = [
      'buy-buttons button[type="submit"]',
      'buy-buttons button',
      '.buy-buttons button[type="submit"]',
      'button[name="add"]',
      'form[is="product-form"] button[type="submit"]',
      'form[action*="/cart/add"] button[type="submit"]',
      '.product-form__submit'
    ];

    for (var i = 0; i < selectors.length; i += 1) {
      var nodes = document.querySelectorAll(selectors[i]);
      for (var j = 0; j < nodes.length; j += 1) {
        var btn = nodes[j];
        if (!isVisible(btn)) continue;
        if (btn.closest && btn.closest('[' + VARIANT_ATTR + ']')) continue;
        if (looksLikeAtc(btn) || btn.getAttribute('name') === 'add') return btn;
      }
    }

    var buttons = document.querySelectorAll('button, [role="button"]');
    for (var k = 0; k < buttons.length; k += 1) {
      var el = buttons[k];
      if (!isVisible(el)) continue;
      if (el.closest && el.closest('[' + VARIANT_ATTR + ']')) continue;
      if (looksLikeAtc(el)) return el;
    }

    return null;
  }

  function getAtcInsertTarget() {
    var atc = getAtcButton();
    if (!atc) return null;
    return (
      atc.closest(
        'buy-buttons, .buy-buttons, .product-info__buy-buttons, [data-block-type="buy-buttons"], .product-form__buttons'
      ) || atc
    );
  }

  function looksLikeSaleHeader(el) {
    if (!el) return false;
    var t = textOf(el);
    if (!t || t.length > 220) return false;
    if (/summer\s+sale|free\s+gifts\s+with\s+your\s+first\s+order|french\s+days/i.test(t)) return true;
    if (/\bHRS\b/.test(t) && /\bMIN\b/.test(t) && /\bSEC\b/.test(t)) return true;
    return false;
  }

  function findSaleHeaderNear(sourceRoot, cards) {
    var anchors = [];
    if (sourceRoot) anchors.push(sourceRoot);
    for (var i = 0; i < (cards || []).length; i += 1) {
      if (cards[i] && anchors.indexOf(cards[i]) === -1) anchors.push(cards[i]);
    }
    if (!anchors.length) return null;

    for (var a = 0; a < anchors.length; a += 1) {
      var node = anchors[a];
      var parent = node.parentElement;
      for (var depth = 0; depth < 5 && parent; depth += 1) {
        var kids = parent.children || [];
        for (var k = 0; k < kids.length; k += 1) {
          var child = kids[k];
          if (child === node || (sourceRoot && child.contains(sourceRoot))) continue;
          if (cards && cards.some && cards.some(function (c) { return c && child.contains(c); })) continue;
          if (looksLikeSaleHeader(child) && !isUnsafeToHide(child)) return child;
        }
        if (looksLikeSaleHeader(parent) && !isUnsafeToHide(parent) && textOf(parent).length < 800) {
          return parent;
        }
        parent = parent.parentElement;
      }
    }
    return null;
  }

  function giftImageUrl(key) {
    var c = cfg();
    return c[key] || '';
  }

  function giftImgTag(src, label) {
    if (!src) return '';
    return (
      '<img src="' +
      src +
      '" alt="' +
      label +
      '" loading="eager" decoding="async" fetchpriority="high" draggable="false">'
    );
  }

  function buildVariantHtml() {
    var cards = '';
    for (var i = 0; i < GIFTS.length; i += 1) {
      var gift = GIFTS[i];
      var src = giftImageUrl(gift.key);
      cards +=
        '<div class="elios-fg-ab__card" data-elios-fg-card="' +
        gift.key +
        '">' +
        '<div class="elios-fg-ab__media">' +
        giftImgTag(src, gift.label) +
        '</div>' +
        '<p class="elios-fg-ab__label">' +
        gift.label +
        '</p>' +
        '</div>';
    }
    return '<div class="elios-fg-ab__grid">' + cards + '</div>';
  }

  function placeVariant(root) {
    if (!root) return false;
    var target = getAtcInsertTarget();
    if (!target || !target.parentNode) return false;
    if (root.nextSibling !== target) {
      target.parentNode.insertBefore(root, target);
    }
    return true;
  }

  function ensureVariant() {
    var existing = document.querySelector('[' + VARIANT_ATTR + ']');
    if (existing) {
      if (existing.getAttribute('data-elios-fg-v') !== VERSION) {
        existing.innerHTML = buildVariantHtml();
        existing.setAttribute('data-elios-fg-v', VERSION);
      }
      placeVariant(existing);
      return existing;
    }

    var root = document.createElement('div');
    root.setAttribute(VARIANT_ATTR, 'true');
    root.setAttribute(MARK, 'true');
    root.setAttribute('data-elios-fg-v', VERSION);
    root.className = 'elios-fg-ab';
    root.hidden = true;
    root.innerHTML = buildVariantHtml();
    placeVariant(root);
    return root;
  }

  function clearHiddenSources() {
    var nodes = document.querySelectorAll('[' + SOURCE_ATTR + ']');
    for (var i = 0; i < nodes.length; i += 1) {
      nodes[i].removeAttribute(SOURCE_ATTR);
    }
  }

  function markSource(el) {
    if (!el || isUnsafeToHide(el)) return;
    if (el.getAttribute(SOURCE_ATTR) === 'true') return;
    el.setAttribute(SOURCE_ATTR, 'true');
  }

  function setSourcesHidden(sourceRoot, cards, hidden) {
    if (!hidden) {
      clearHiddenSources();
      return;
    }

    var next = [];
    var saleHeader = findSaleHeaderNear(sourceRoot, cards);

    if (sourceRoot && !isUnsafeToHide(sourceRoot)) {
      next.push(sourceRoot);
    } else {
      for (var i = 0; i < (cards || []).length; i += 1) {
        if (cards[i] && !isUnsafeToHide(cards[i])) next.push(cards[i]);
      }
    }

    if (
      saleHeader &&
      saleHeader !== sourceRoot &&
      !isUnsafeToHide(saleHeader) &&
      !(sourceRoot && saleHeader.contains(sourceRoot))
    ) {
      next.push(saleHeader);
    }

    var current = document.querySelectorAll('[' + SOURCE_ATTR + ']');
    if (current.length === next.length) {
      var same = true;
      for (var n = 0; n < next.length; n += 1) {
        if (next[n].getAttribute(SOURCE_ATTR) !== 'true') {
          same = false;
          break;
        }
      }
      if (same) return;
    }

    clearHiddenSources();
    for (var k = 0; k < next.length; k += 1) markSource(next[k]);
  }

  function syncImages(root) {
    if (!root) return;
    for (var i = 0; i < GIFTS.length; i += 1) {
      var gift = GIFTS[i];
      var card = root.querySelector('[data-elios-fg-card="' + gift.key + '"]');
      if (!card) continue;

      var labelEl = card.querySelector('.elios-fg-ab__label');
      if (labelEl && labelEl.textContent !== gift.label) {
        labelEl.textContent = gift.label;
      }

      var media = card.querySelector('.elios-fg-ab__media');
      var url = giftImageUrl(gift.key);
      if (!media || !url) continue;

      var img = media.querySelector('img');
      if (!img) {
        media.innerHTML = giftImgTag(url, gift.label);
        continue;
      }

      if (img.getAttribute('src') !== url) {
        img.setAttribute('src', url);
        img.removeAttribute('srcset');
        img.removeAttribute('sizes');
        img.removeAttribute('width');
        img.removeAttribute('height');
      }
      if (img.getAttribute('alt') !== gift.label) img.setAttribute('alt', gift.label);
    }
  }

  function clearSettleTimers() {
    for (var i = 0; i < settleTimers.length; i += 1) {
      window.clearTimeout(settleTimers[i]);
    }
    settleTimers = [];
  }

  /** Late GemPages / ATC — few one-shot retries, then stop (no continuous observer) */
  function scheduleSettlePasses() {
    clearSettleTimers();
    var delays = [300, 800, 1600, 3000];
    for (var i = 0; i < delays.length; i += 1) {
      (function (ms) {
        settleTimers.push(
          window.setTimeout(function () {
            apply(true);
          }, ms)
        );
      })(delays[i]);
    }
  }

  /**
   * @param {boolean} fromSettle - settle retry; skip if already enabled+placed
   */
  function apply(fromSettle) {
    if (applying) return;
    applying = true;

    try {
      if (!isProductPage()) {
        document.documentElement.classList.remove(ACTIVE_CLASS);
        clearHiddenSources();
        lastEnabled = false;
        return;
      }

      var enabled = isAbEnabled();

      if (fromSettle && enabled === lastEnabled) {
        var existing = document.querySelector('[' + VARIANT_ATTR + ']');
        if (enabled && existing && !existing.hidden && existing.nextSibling) {
          // Still try to hide late-loading source cards once
          var hits = findLabelNodes();
          setSourcesHidden(findSourceRoot(hits), findSourceCards(hits), true);
          placeVariant(existing);
          return;
        }
        if (!enabled && (!existing || existing.hidden)) return;
      }

      var labelHits = findLabelNodes();
      var sourceRoot = findSourceRoot(labelHits);
      var sourceCards = findSourceCards(labelHits);
      var variant = ensureVariant();

      placeVariant(variant);
      syncImages(variant);

      if (enabled) {
        document.documentElement.classList.add(ACTIVE_CLASS);
        if (document.body && isDevVariantB() && document.body.getAttribute(BODY_ATTR) !== 'true') {
          document.body.setAttribute(BODY_ATTR, 'true');
        }
        if (variant) {
          variant.hidden = false;
          if (variant.style.display === 'none') variant.style.display = '';
        }
        setSourcesHidden(sourceRoot, sourceCards, true);
      } else {
        document.documentElement.classList.remove(ACTIVE_CLASS);
        if (variant) {
          variant.hidden = true;
          variant.style.display = 'none';
        }
        clearHiddenSources();
      }

      lastEnabled = enabled;
    } catch (err) {
      try {
        clearHiddenSources();
        document.documentElement.classList.remove(ACTIVE_CLASS);
      } catch (e2) {}
      if (typeof console !== 'undefined' && console.warn) {
        console.warn('[elios-free-gifts-ab]', err);
      }
    } finally {
      applying = false;
    }
  }

  function run(forceSettle) {
    apply(false);
    if (forceSettle || isAbEnabled()) scheduleSettlePasses();
  }

  function init() {
    if (isDevVariantB()) {
      if (document.documentElement.getAttribute(BODY_ATTR) !== 'true') {
        document.documentElement.setAttribute(BODY_ATTR, 'true');
      }
      if (document.body && document.body.getAttribute(BODY_ATTR) !== 'true') {
        document.body.setAttribute(BODY_ATTR, 'true');
      }
    }

    run(true);
    if (!document.body) return;

    // Attribute-only — NO childList/subtree (that caused the infinite loop)
    attrObserver = new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i += 1) {
        var m = mutations[i];
        if (
          m.attributeName === BODY_ATTR ||
          m.attributeName === 'data-gem-variant' ||
          m.attributeName === 'data-gem-test-active'
        ) {
          run(true);
          return;
        }
      }
    });

    attrObserver.observe(document.body, {
      attributes: true,
      attributeFilter: [BODY_ATTR, 'data-gem-variant', 'data-gem-test-active']
    });

    if (document.documentElement) {
      attrObserver.observe(document.documentElement, {
        attributes: true,
        attributeFilter: [BODY_ATTR]
      });
    }

    document.addEventListener('shopify:section:load', function () {
      run(true);
    });
  }

  window.EliosFreeGiftsABTest = {
    enable: function () {
      if (!document.body) return;
      document.body.setAttribute(BODY_ATTR, 'true');
      run(true);
    },
    disable: function () {
      if (!document.body) return;
      document.body.setAttribute(BODY_ATTR, 'false');
      clearSettleTimers();
      apply(false);
    },
    isActive: isAbEnabled,
    hydrate: function () {
      run(true);
    }
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
